import React from 'react'
import './Footer.css'
const Footer = () => {
    const year = new Date().getFullYear();

    return (
        <div>
            
    
<footer class="site-footer">
<div class="container">
  <div class="row">
    <div class="col-sm-12 col-md-6">
      <h6>About</h6>
      <p class="text-justify">NooBGeeks <i>CODE WANTS TO BE SIMPLE </i> is an initiative  to help the upcoming programmers with the code. NooBGeeks focuses on providing the most efficient code or snippets as the code wants to be simple. We will help programmers build up concepts in different programming languages that include C, C++, Java, Python and Algorithm.</p>
    </div>

    <div class="col-xs-6 col-md-3">
      <h6>Categories</h6>
      <ul class="footer-links">
        <li><a href="/category/c">C</a></li>
        <li><a href="/category/cpp">C++</a></li>
        <li><a href="/category/java">Java</a></li>
        <li><a href="/category/python">Python</a></li>
      </ul>
    </div>

    <div class="col-xs-6 col-md-3">
      <h6>Quick Links</h6>
      <ul class="footer-links">
        <li><a href="/about">About Us</a></li>
        <li><a href="mailto:mohitkushwaha4508@gmail.com">Contact Us</a></li>
      </ul>
    </div>
  </div>
  <hr/>
</div>
<div class="container">
  <div class="row">
    <div class="col-md-8 col-sm-6 col-xs-12">
      <p class="copyright-text"> copyright © {year} reserved by NooBGeeks
      </p>
    </div>

    
  </div>
</div>
</footer>
</div>
    )
}

export default Footer
